<template>
  <div class="message-container ib-background-red">
    <div class="icon-container ib-color-white">
      <q-icon name="icon-con-toast"></q-icon>
    </div>
    <div class="text-container">
      <div class="ibf-h7 ib-color-white">{{ title }}</div>
      <div class="ibf-h7 ib-color-white">{{ body }}</div>
    </div>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  name: 'LinkDownMessage',
  props: {
    title: {
      type: String,
      default: i18n.global.t('generic.linkDown.title'),
    },
    body: {
      type: String,
      default: i18n.global.t('generic.linkDown.body'),
    },
  },
};
</script>

<style lang="scss" scoped>
.message-container {
  position: fixed;
  top: 20px;
  right: 20px;
  left: 95px;
  height: 60px;
  z-index: 4000;
  display: flex;
  justify-content: flex-start;

  & .icon-container {
    height: 100%;
    width: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & .text-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
